import React from 'react';
import { Col, Modal, Row } from 'reactstrap';

// import { Mobile, Desktop } from '../Common/const';
// import FriendStats from '../../containers/FriendProfileContainers/friendStatsContainer';
// import FriendActivity from '../../containers/FriendProfileContainers/friendActivityContainer';
// import FriendBadges from '../../containers/FriendProfileContainers/friendBadgesContainer';
// import FriendScoringHistory from '../../containers/FriendProfileContainers/friendScoringHistoryContainer';
import FriendHeader from '../../containers/FriendProfileContainers/friendHeaderContainer';

class FriendProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requestSent: false,
    };
  }

  render() {
    return (
      <div>
        <Modal
          toggle={() => this.props.openFriendProfile(false, null)}
          isOpen={this.props.isOpen}
          centered
          className="friend-profile-popup py-5"
        >
          <i
            onClick={() => this.props.openFriendProfile(false, null)}
            className="icon-close"
          />
          <FriendHeader className="mb-2" />
          {false ? (
            <Row className="m-0">
              {/* <Col xs={12} md={6} className="mt-4">
                <FriendStats />
              </Col> */}
              {/* <Col xs={12} md={6} className="mt-4">
                <FriendActivity
                  gradientId="gradientActyvityProgressBar"
                  localStorageItem="optionSelectFriendActivity"
                />
              </Col> */}
              {/* <Col xs={12} className="mt-4">
                <FriendScoringHistory />
              </Col> */}
              {/* <Col xs={12} className="mt-4">
                <Mobile>
                  <FriendBadges badgesPerScreen={6} />
                </Mobile>
                <Desktop>
                  <FriendBadges badgesPerScreen={14} />
                </Desktop>
              </Col> */}
            </Row>
          ) : (
            <Row className="m-0">
              <Col className="text-center private-profile">
                <div className="circle-icon m-auto d-flex text-center">
                  <i className="icon-lock m-auto" />
                </div>
                <h4 className="mt-3">This is a private profile</h4>
              </Col>
            </Row>
          )}
        </Modal>
      </div>
    );
  }
}
export default FriendProfileView;
